import { render } from "./DropdownComponent.vue?vue&type=template&id=1a9b968b&scoped=true"
import script from "./DropdownComponent.vue?vue&type=script&lang=js"
export * from "./DropdownComponent.vue?vue&type=script&lang=js"

import "./DropdownComponent.vue?vue&type=style&index=0&id=1a9b968b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9b968b"]])

export default __exports__